import { ActivityAction } from "@/app/activity/activity-action"
import { ActivityDate } from "@/app/activity/activity-time"
import { WalletAddressLink } from "@/app/components/wallet-address"
import { ArrowIcon } from "@/app/icons/arrow"
import { PriceWrapper } from "@/app/price"
import type { ActivityWithNft } from "@anaconda/core/activity/types"
import { Trans } from "@lingui/react/macro"
import { Skeleton } from "@rarible_int/anaconda_ui_components"
import {
  NftMiniature,
  NftMiniatureSkeleton,
} from "../../nft/miniautre/nft-miniature"
import { HeaderCell } from "./cells"

interface Column {
  Header: React.ComponentType
  Content: React.ComponentType<ActivityWithNft>
  Skeleton: React.ComponentType
}

export const COLUMNS: Column[] = [
  {
    Header: () => (
      <HeaderCell className="w-[100px]">
        <Trans>Time</Trans>
      </HeaderCell>
    ),
    Content: (activity) => <ActivityDate date={new Date(activity.date)} />,
    Skeleton: () => <Skeleton className="h-6 w-8" />,
  },
  {
    Header: () => (
      <HeaderCell className="w-[80px]">
        <Trans>Action</Trans>
      </HeaderCell>
    ),
    Content: (activity) => <ActivityAction type={activity.type} />,
    Skeleton: () => <Skeleton className="h-[22px] w-[44px]" />,
  },
  {
    Header: () => (
      <HeaderCell className="w-[250px] md:w-[330px]">
        <Trans>Item</Trans>
      </HeaderCell>
    ),
    Content: (activity) => <NftMiniature nft={activity.nft} />,
    Skeleton: NftMiniatureSkeleton,
  },
  {
    Header: () => (
      <HeaderCell className="w-[160px]">
        <Trans>Value</Trans>
      </HeaderCell>
    ),
    Content: (activity) =>
      activity.price.amount !== "0" ? (
        <PriceWrapper {...activity.price} />
      ) : (
        <>-</>
      ),
    Skeleton: () => <Skeleton className="h-[22px] w-[100px]" />,
  },
  {
    Header: () => (
      <HeaderCell className="w-[120px] md:w-[220px]">
        <Trans>From</Trans>
      </HeaderCell>
    ),
    Content: (activity) => (
      <>
        {activity.seller ? (
          <WalletAddressLink
            address={activity.seller}
            prefetch={false}
            withAvatar
          />
        ) : (
          "-"
        )}
      </>
    ),
    Skeleton: () => <Skeleton className="h-6 w-[108px]" />,
  },
  {
    Header: () => (
      <HeaderCell className="w-[40px] md:w-[80px]">{null}</HeaderCell>
    ),
    Content: () => <ArrowIcon />,
    Skeleton: () => <ArrowIcon />,
  },
  {
    Header: () => (
      <HeaderCell className="w-[120px] md:w-[220px]">
        <Trans>To</Trans>
      </HeaderCell>
    ),
    Content: (activity) => (
      <WalletAddressLink address={activity.buyer} prefetch={false} withAvatar />
    ),
    Skeleton: () => <Skeleton className="h-6 w-[108px]" />,
  },
]
